import React from "react";
import styled from "styled-components";

const RenderSocialItem = (item, index) => {
  switch (item.SocialShareType) {
    case "LinkedIn": {
      const shareUrl = `${item.ShareUrl}?url=${window.location.href}`;
      return (
        <SocialItemWrapper key={index}>
          <ItemLink href={shareUrl} target="_blank" title={item.ButtonTitle}>
            <i className="fa-brands fa-linkedin-in" aria-hidden="true"></i>
          </ItemLink>
        </SocialItemWrapper>
      );
    }
    case "Facebook": {
      const shareUrl = `${item.ShareUrl}?u=${window.location.href}`;
      return (
        <SocialItemWrapper key={index}>
          <ItemLink href={shareUrl} target="_blank" title={item.ButtonTitle}>
            <i className="fa-brands fa-facebook-f" aria-hidden="true"></i>
          </ItemLink>
        </SocialItemWrapper>
      );
    }
    case "Twitter": {
      const shareUrl = `${item.ShareUrl}?text=Norlandia&url=${window.location.href}`;
      return (
        <SocialItemWrapper key={index}>
          <ItemLink href={shareUrl} target="_blank" title={item.ButtonTitle}>
            <i className="fa-brands fa-twitter" aria-hidden="true"></i>
          </ItemLink>
        </SocialItemWrapper>
      );
    }
    case "Email": {
      const shareUrl = `${item.ShareUrl}?subject=Norlandia&amp;body=${window.location.href}`;
      return (
        <SocialItemWrapper key={index} title={item.ButtonTitle}>
          <ItemLink href={shareUrl} target="_blank">
            <i className="fa-solid fa-envelope" aria-hidden="true"></i>
          </ItemLink>
        </SocialItemWrapper>
      );
    }
  }
};

export const SocialShare = ({ share }) => {
  return (
    <SocialSectionWrapper id="social-share">
      {share?.map((social, index) => RenderSocialItem(social, index))}
    </SocialSectionWrapper>
  );
};

const SocialSectionWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 24px 0 24px;
`;

const SocialItemWrapper = styled.div`
  width: 40px;
  height: 40px;
  background: #ebebeb;
  padding: 5px;
  border-radius: 55px;
`;

const ItemLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #808080;
  transition: 0.3s;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #000000;
  }
`;
